import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { customerCategoryLabel, DEFAULT_CUSTOMER_CATEGORIES } from '@erp/shared';
import { useCustomerCategories } from '../api/use-business-terms';
export function useCustomerCategoryLabel(): (code: string | null) => string {
  const query = useCustomerCategories();
  const { t, i18n } = useTranslation();
  return useCallback(
    (code: string | null) => {
      const entry = (query.data?.data ?? DEFAULT_CUSTOMER_CATEGORIES).find(
        (row) => row.code === code,
      );
      return entry
        ? customerCategoryLabel(entry, i18n.language)
        : code
          ? t(`partners.industries.${code}`, { defaultValue: code })
          : '—';
    },
    [query.data, t, i18n.language],
  );
}
